import React, { useEffect } from "react";

import NavbarService from "./NavbarService";

function VastuPage() {
  const whatsappNumber = "919332283222"; 
 const whatsappMessage ="Hello, I want to know more about Vastu Consultancy services.";
 

  return (
    <>
    <NavbarService/>
        <div className="container mb-5"  style={{marginTop:"8rem"}} >
            <div className="row justify-content-center">
                <div className="col-md-10">
                <div className="card shadow-lg border-0 p-4">
                    <div className="card-body">
                    <h2 className="text-center mb-3">Vastu Consultant</h2>
                    <p className="text-center text-muted">
                        Transform your spaces into hubs of positivity and harmony with
                        our expert Vastu Planning and Consultancy. Achieve balance and
                        prosperity by aligning your home or workplace with ancient Vastu
                        principles.
                    </p>

                    <h4 className="mt-4">What We Offer</h4>
                    <ul>
                        <li>Vastu analysis for Home, Office, Shops & factory</li>
                        <li>Remedies without demolition</li>
                        <li>Personalized Vastu planning for new constructions</li>
                        <li>Energy balancing and space healing</li>
                    </ul>

                    <div className="mt-4 p-3 bg-light rounded">
                        <h5 className="mb-2">Consultancy Mode:</h5>
                        <p className="mb-1"><b>Online</b> – via video call / chat</p>
                        <p><b>Offline</b> – site visit and in-person consultation</p>
                    </div>

                    <div className="mt-4 p-3 bg-light rounded shadow-sm">
                        <h5 className="mb-1">
                        <span className="text-muted text-decoration-line-through">5000</span>{" "}
                        <span className="text-success fw-bold">₹2000 / consultation</span>
                        </h5>
                        <small className="text-danger fw-semibold">
                        ({Math.round(((5000 - 2000) / 5000) * 100)}% OFF)
                        </small>
                        <p className="text-muted mt-2 mb-0">
                        Charges may vary for site visits depending on location.
                        </p>
                    </div>

                    <div className="mt-4 d-flex gap-3">
                        <a
                        href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
                            whatsappMessage
                        )}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-success"
                        >
                        WhatsApp Us
                        </a>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </div>
    </>
  
  );
}

export default VastuPage;
